const dataRoadMap = [
    {
        title: 'Collection',
        text: 'Journals, papers, pictures, objects, even audio and video.',
        time: 'Understanding the scope',
        class: 'top'
    },
    {
        title: 'Curation',
        text: 'Delicately edit your content to carefully craft your narrative.',
        time: 'Crafting the narrative',
        class: 'bottom'
    },
    {
        title: 'Creation',
        text: 'Your narrative organized into a book full of contents of your life.',
        time: 'Design and layout',
        class: 'top'
    },
    {
        title: 'Delivery',
        text: 'Make an archival album, cofee table book, or magazine...or all three.  ',
        time: 'Physical copies',
        class: 'bottom'
    },
    {
        title: 'Chapters',
        text: 'Have a lot to share or only want to share a selection sometimes',
        time: 'Divded into chapters',
        class: 'top'
    },
]

export default dataRoadMap;